/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Custom Buttons for app
 */
import { JSX, PureComponent } from 'react';
import { Button as AntButton, ButtonProps } from 'antd';

import Home from './Home';
import Reload from './Reload';
import GoBack from './GoBack';
import Logout from './Logout';

/**
 * Custom Buttons for app
 */
class AppButton extends PureComponent<ButtonProps> {
	static Home = Home;
	static Reload = Reload;
	static GoBack = GoBack;
	static Logout = Logout;

	render(): JSX.Element {
		const { children, ...props } = this.props;
		return <AntButton {...props}>{children}</AntButton>;
	}
}

export default AppButton;
